import { render, staticRenderFns } from "./Mobi.vue?vue&type=template&id=f6913fc2"
import script from "./Mobi.vue?vue&type=script&lang=js"
export * from "./Mobi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports